import { createApp } from "vue";

import YouTubeView from "./YouTubeView.vue";
import $ from "jquery";

const obj = {
  view: null,
  install(Vue: any) {
    if (this.view) {
      setMethod(Vue, this.view);
    } else {
      const instance = createApp(YouTubeView);
      instance.use({
        install: function (Vue, options) {
          Vue.config.globalProperties.$jQuery = $;
        },
      });
      const parent = document.createElement("div");
      const bodyDom = document.body;
      bodyDom.appendChild(parent);
      this.view = instance.mount(parent);
      setMethod(Vue, this.view);
    }
  },
};

function setMethod(Vue, view) {
  Vue.config.globalProperties.Youtube = {
    show: view.show,
    hide: view.hide,
  };
}

export default obj;
